import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface LoginResponse {
  access_token: string,
  user: User,
  expires: Date
}

export interface User {
  id: number;
  username: string;
  full_name: string;
  email: string;
  roles: string[];
  loginExpiresAt: Date;
  /** Foglalkoztatás típusa — külsősnél nincs szabadság-elszámolás. */
  employment_type?: 'employee' | 'external';
  /** Menü-láthatóság (nav-címke → látható). Hiányzó kulcs = látható. */
  menus?: Record<string, boolean>;
  /** szerepnevek a users/me-ből (pl. ['admin']) */
  roleNames?: string[];
  /** profilkép fájlneve (users/images/:file) */
  image_file?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  jwt: string | null = null;
  user: User | null;
  
  isAuthenticatedSubject = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  checkUserValidity(): Observable<boolean> {
    return new Observable(observer => {
        this.http.get<{ menus?: Record<string, boolean> | null; roleNames?: string[]; full_name?: string; image_file?: string | null }>('users/me').subscribe({
          next: (me) => {
            // A menü-jogosultság frissen a szerverről: az admin módosítása új belépés nélkül is érvényesül.
            if (this.user && me) {
              this.user.menus = me.menus || undefined;
              this.user.roleNames = me.roleNames || this.user.roleNames;
              this.user.full_name = me.full_name || this.user.full_name;
              this.user.image_file = me.image_file ?? this.user.image_file;
              localStorage.setItem('user', JSON.stringify(this.user));
            }
            this.isAuthenticatedSubject.next(true);
            observer.next();
            observer.complete();
          },
          error: (error) => {
            // Hálózati hiba (nincs térerő, offline PWA-indítás) ≠ lejárt belépés: ilyenkor nem dobjuk ki
            // a felhasználót a belépő képernyőre — a mentett munkamenettel megy tovább, az oldalak
            // újrapróbálnak, amint van kapcsolat. Valódi elutasításnál (401/403) marad a kiléptetés.
            // (A service worker a hálózati hibát 504-ként adja vissza; élesítés közben a szerver 502/503-at ad.)
            const networkError = !error?.status || [502, 503, 504].includes(error.status);
            this.isAuthenticatedSubject.next(networkError && !!this.jwt && !!this.user);
            observer.next();
            observer.complete();
          }
        })
    });

  }

  login(username: string, pwd: string) {
    return new Observable(observer => {
      this.http.post<LoginResponse>('auth/login', {
        username: username,
        password: pwd
      }).subscribe({
        next: (response) => {
          this.onSuccessfullLogin(response);
          observer.next()
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  logout() {
    this.jwt = null;
    this.user = null;
    this.isAuthenticatedSubject.next(false);
    localStorage.removeItem('jwt');
    localStorage.removeItem('user');
  }

  onSuccessfullLogin(response: LoginResponse) {
    this.jwt = response.access_token;
    this.user = response.user;
    this.user.loginExpiresAt = response.expires;
    console.log(this.user);
    localStorage.setItem('jwt',this.jwt);
    localStorage.setItem('user',JSON.stringify(this.user));
    this.isAuthenticatedSubject.next(true);
  }

  restoreUser() {
    if(localStorage.getItem('jwt')) {
        this.jwt = localStorage.getItem('jwt');        
    }
    if(localStorage.getItem('user')) {
      this.user = JSON.parse(localStorage.getItem('user') as string);
    }
}

  isAuthenticated() {
    return this.isAuthenticatedSubject.value;
  }
}
